export const apiI18n = {
  not_found: {
    'zh-TW': '找不到資源',
    'en': 'TEMP_MESSAGE'
  },
  unauthorized: {
    'zh-TW': '未授權的帳號',
    'en': 'TEMP_MESSAGE'
  },
  invalid_parameter: {
    'zh-TW': '參數錯誤',
    'en': 'TEMP_MESSAGE'
  },
  email_registered: {
    'zh-TW': '電子信箱已註冊',
    'en': 'TEMP_MESSAGE'
  },
  email_unregistered: {
    'zh-TW': '電子信箱未註冊',
    'en': 'TEMP_MESSAGE'
  },
  sign_up_success: {
    'zh-TW': '註冊成功，請至註冊時填寫的電子信箱收取確認信',
    'en': 'TEMP_MESSAGE'
  },
  email_unconfirmed: {
    'zh-TW': '電子信箱未驗證',
    'en': 'TEMP_MESSAGE'
  },
  user_disabled: {
    'zh-TW': '帳號未啟用',
    'en': 'TEMP_MESSAGE'
  },
  sign_out_success: {
    'zh-TW': '帳號已登出',
    'en': 'TEMP_MESSAGE'
  },
  sent_email_confirmation_link: {
    'zh-TW': '電子信箱確認連結已寄到使用者電子信箱',
    'en': 'TEMP_MESSAGE'
  },
  confirm_email_success_wait_enable: {
    'zh-TW': '電子信箱驗證成功，請等待業務人員啟用帳號',
    'en': 'TEMP_MESSAGE'
  },
  confirm_email_success: {
    'zh-TW': '電子信箱驗證成功',
    'en': 'TEMP_MESSAGE'
  },
  confirm_email_failed: {
    'zh-TW': '電子信箱驗證失敗',
    'en': 'TEMP_MESSAGE'
  },
  sent_reset_password_link: {
    'zh-TW': '重置密碼連結已寄到使用者電子信箱',
    'en': 'TEMP_MESSAGE'
  },
  user_not_found: {
    'zh-TW': '找不到使用者',
    'en': 'TEMP_MESSAGE'
  },
  reset_password_success: {
    'zh-TW': '重置密碼成功，請重新登入',
    'en': 'TEMP_MESSAGE'
  },
  invalid_reset_password_token: {
    'zh-TW': '重置密碼權杖錯誤',
    'en': 'TEMP_MESSAGE'
  },
  email_confirmed: {
    'zh-TW': '電子信箱已驗證',
    'en': 'TEMP_MESSAGE'
  },
  wrong_original_password: {
    'zh-TW': '舊密碼不正確',
    'en': 'TEMP_MESSAGE'
  },
  create_subuser_success_wait_confirm: {
    'zh-TW': '成功建立子帳號，確認連結已寄到使用者的電子信箱',
    'en': 'TEMP_MESSAGE'
  },
  delete_subuser_success: {
    'zh-TW': '成功刪除子帳號',
    'en': 'TEMP_MESSAGE'
  },
  delete_subuser_failed: {
    'zh-TW': '刪除子帳號失敗',
    'en': 'TEMP_MESSAGE'
  },
  require_hospital_medical_license: {
    'zh-TW': '必須有醫院執照才可以進行此操作',
    'en': 'TEMP_MESSAGE'
  },
  require_medical_license: {
    'zh-TW': '必須有醫生執照才可以進行此操作',
    'en': 'TEMP_MESSAGE'
  },
  create_case_success_wait_agree: {
    'zh-TW': '案件已提交，等待使用者同意中',
    'en': 'TEMP_MESSAGE'
  },
  create_case_success: {
    'zh-TW': '成功建立案件',
    'en': 'TEMP_MESSAGE'
  },
  agree_user_policy_success: {
    'zh-TW': '您已同意使用者條款，成功建立案件',
    'en': 'TEMP_MESSAGE'
  },
  disagree_user_policy_success: {
    'zh-TW': '您已拒絕使用者條款，案件不成立',
    'en': 'TEMP_MESSAGE'
  },
  user_policy_failed: {
    'zh-TW': '使用者條款建立失敗',
    'en': 'TEMP_MESSAGE'
  },
  enable_user_success: {
    'zh-TW': '啟用帳號成功',
    'en': 'TEMP_MESSAGE'
  },
  invalid_enable_user_token: {
    'zh-TW': '啟用帳號權杖錯誤',
    'en': 'TEMP_MESSAGE'
  }
}

export const occupationOptions = [
  { title: '貿易商', value: '貿易商' },
  { title: '農政人員', value: '農政人員' },
  { title: '研究人員', value: '研究人員' },
  { title: '農產品經營業者', value: '農產品經營業者' },
  { title: '其他', value: 'other' }
]

export const roleOptions = [
  { title: '一般', value: '' },
  { title: '進階', value: 'advance' }
]



// WEBPACK FOOTER //
// ./src/constants/global/data.js